export default [
  {
    path: '/agents/create',
    name: 'AgentCreate',
    component: () => import(/* webpackChunkName: "agents" */ '@/views/agents/AgentCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AgentList',
      requireAuth: true,
      requireAccount: true,
      requireAgents: true,
      title: 'Crear agente'
    }
  },
  {
    path: '/agents/inbox',
    name: 'AgentInbox',
    component: () => import(/* webpackChunkName: "agents" */ '@/views/agents/AgentInbox.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AgentList',
      requireAuth: true,
      requireAccount: true,
      requireAgents: true,
      title: 'Feed'
    }
  },
  {
    path: '/agents/:id',
    name: 'AgentRetrieve',
    component: () => import(/* webpackChunkName: "agents" */ '@/views/agents/AgentRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AgentList',
      requireAuth: true,
      requireAccount: true,
      requireAgents: true,
      title: 'Agente'
    }
  },
  {
    path: '/agents/all',
    name: 'AgentList',
    component: () => import(/* webpackChunkName: "agents" */ '@/views/agents/AgentList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'AgentList',
      requireAuth: true,
      requireAccount: true,
      requireAgents: true,
      title: 'Agentes'
    }
  }
]
